import React, { useState } from "react";
import { Form } from "react-bootstrap";
import CampaignChannelDropdown from "../../../../components/specific/dropdowns/CampaignChannelDropdown";
import ContentWrapper from "../../../Wrapper";
import AccountDetailsSubheader from "../../components/account-details-subheader";
import AccountCampaignPricingEmail from "./account-campaign-pricing-email";
import AccountCampaignPricingSms from "./account-campaign-pricing-sms";
import AccountCampaignPricingWhatsapp from "./account-campaign-pricing-whatsapp";
import AccountCampaignPricingEmailFinder from "./account-campaign-pricing-email-finder";
import AccountCampaignPricingEmailValidation from "./account-campaign-pricing-email-validation";
import AccountCampaignPricingWhatsapp2 from "./account-campaign-pricing-whatsapp2";
import AccountCampaignPricingRCS from "./account-campaign-pricing-rcs";

export default function AccountCampaignPricing() {
  const tabName = "Campaign pricing";
  const [activeChannel, setActiveChannel] = useState("sms");
  const [search, setSearch] = useState("");
  return (
    <ContentWrapper
      subHeader={
        <AccountDetailsSubheader active={tabName}>
          <div className="d-flex gap-4 align-items-center">
            {(activeChannel === "sms" || activeChannel === "whatsapp2" || activeChannel === "rcs") && <div className="w-300px">
              <Form.Control
                value={search}
                onChange={e => { setSearch(e.target.value); }}
                placeholder="Search country here..."
              />
            </div>}
            <CampaignChannelDropdown defaultValue={activeChannel} handleSelect={(selected) => setActiveChannel(selected.value)} />
          </div>
        </AccountDetailsSubheader>
      }
    >
      {activeChannel === "email" && <AccountCampaignPricingEmail />}
      {activeChannel === "sms" && <AccountCampaignPricingSms search={search} setSearch={setSearch} />}
      {activeChannel === "whatsapp" && <AccountCampaignPricingWhatsapp />}
      {activeChannel === "whatsapp2" && <AccountCampaignPricingWhatsapp2 search={search} setSearch={setSearch} />}
      {activeChannel === "rcs" && <AccountCampaignPricingRCS search={search} setSearch={setSearch} />}
      {activeChannel === "email_finder" && <AccountCampaignPricingEmailFinder />}
      {activeChannel === "email_validation" && <AccountCampaignPricingEmailValidation />}
    </ContentWrapper>
  );
}
